module.exports = __webpack_public_path__ + "static/img/sy-xx@2x.4fd9e873.png";